import { NotificationContent, NotificationContentDetails } from '@hr-outsourcing/shared';
import { TFunction } from 'i18next';
const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;
const normalizeDetails = (value: unknown): NotificationContentDetails | null => {
  if (!value) return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed.length) {
      return null;
    }
    if (trimmed.startsWith('MESSAGES.')) {
      return { translationKey: trimmed };
    }
    return { rawText: trimmed };
  }
  if (isRecord(value)) {
    if (value.details) {
      const nested = normalizeDetails(value.details);
      if (nested) {
        return nested;
      }
    }
    if (typeof value.translationKey === 'string') {
      return {
        translationKey: value.translationKey,
        translationParams: isRecord(value.translationParams)
          ? (value.translationParams as Record<string, unknown>)
          : undefined,
        rawText: typeof value.rawText === 'string' ? value.rawText : undefined,
      };
    }
    if (typeof value.rawText === 'string') {
      return { rawText: value.rawText };
    }
    if (typeof value.raw === 'string') {
      return { rawText: value.raw };
    }
  }
  return null;
};
const interpolateLegacyPlaceholders = (text: string, params?: Record<string, unknown>): string => {
  if (!params) return text;
  return text.replace(/\{(\w+)\}/g, (match, key) => {
    const value = params[key];
    if (value === undefined || value === null) {
      return match;
    }
    return String(value);
  });
};
export const translateNotificationContent = (content: NotificationContent, t: TFunction): string => {
  const details = normalizeDetails(content);
  if (!details) {
    return '';
  }
  if (details.translationKey) {
    const translated = t(details.translationKey, details.translationParams ?? {});
    const text = typeof translated === 'string' && translated.length ? translated : (details.translationKey ?? '');
    return interpolateLegacyPlaceholders(text, details.translationParams);
  }
  if (details.rawText) {
    return interpolateLegacyPlaceholders(details.rawText, details.translationParams);
  }
  return '';
};
